import React from 'react';
import { CHERRY_APPLY_URL } from '../data/pricing';

type Props = {
  className?: string;
  /** denser layout for embedding under pricing cards */
  compact?: boolean;
};

/**
 * Cherry payment plans — listed first among financing options.
 * Links to CHOMP’s unique application URL (no floating widget).
 */
const CherryFinancing: React.FC<Props> = ({ className = '', compact = false }) => {
  return (
    <aside
      className={`rounded-2xl border border-gray-200 bg-white ${
        compact ? 'p-5' : 'p-6 md:p-8'
      } ${className}`}
      aria-label="Cherry payment plans"
    >
      <div
        className={`flex flex-col ${
          compact ? 'sm:flex-row sm:items-center' : 'md:flex-row md:items-center'
        } gap-5 md:gap-8`}
      >
        <a
          href={CHERRY_APPLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 inline-flex items-center justify-center self-start sm:self-center rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2"
        >
          <img
            src="/financing/cherry-logo.svg"
            alt="Cherry payment plans"
            width={160}
            height={45}
            className={compact ? 'h-8 w-auto' : 'h-10 w-auto'}
            loading="lazy"
          />
        </a>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold uppercase tracking-wide text-gray-800 mb-1">
            Pay over time with Cherry
          </p>
          <p className="text-sm text-gray-600 leading-relaxed">
            Split care into monthly payments with Cherry — our primary financing partner.
            Apply in about a minute with no hard credit check.
          </p>
        </div>
        <a
          href={CHERRY_APPLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary shrink-0 text-center text-sm px-5 py-3 whitespace-nowrap"
        >
          Check your options
          <span className="sr-only"> with Cherry (opens in new tab)</span>
        </a>
      </div>
    </aside>
  );
};

export default CherryFinancing;
